import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'

eventBus.$on(eventDefinitions.PRODUCT.PAGE_VIEW, ({ product, variant }) => {
  //
})
